import React from 'react'
import { IonCol, IonGrid, IonRow } from '@ionic/react'
import ButtonComponent, { IButton } from '../button/Button.component'
import BadgeComponent, { IBadge } from '../badge/Badge.component'
import CurrentTimeButton from '../currentTimeButton/CurrentTimeButton.component'
import QuickActionButton from '../quickActionButton/QuickActionButton.component'
import Timer, { ITimer } from '../timer/Timer.component'
import { IQuickActionButton } from '../../features/quickActions/store/quickActions.types'

const ButtonComponents = {
  button: ButtonComponent,
  count: BadgeComponent,
  currentTime: CurrentTimeButton,
  quickAction: QuickActionButton,
  timer: Timer,
}

export interface IDynamicButton {
  key: string
  type: string
  buttonCol?: number
  buttonRow?: number
  id?: number | string
  props: IButton | IBadge | IQuickActionButton | ITimer
}

export interface IButtonRow {
  key: string
  buttons: Array<IDynamicButton>
}

export interface IDynamicButtonWall {
  rows: Array<IButtonRow>
}

const ButtonWallComponent: React.FC<IDynamicButtonWall> = (props: IDynamicButtonWall) => {
  const { rows } = props

  return (
    <>
      <IonGrid class='button-wall-grid'>
        {rows.map((row) => {
          return (
            <IonRow key={row.key}>
              {row.buttons.map(function (button) {
                return (
                  <IonCol sizeMd='3' sizeSm='4' sizeXs='4' key={button.key}>
                    {
                      // @ts-ignore
                      React.createElement(ButtonComponents[button.type], { ...button.props })
                    }
                  </IonCol>
                )
              })}
            </IonRow>
          )
        })}
      </IonGrid>
    </>
  )
}

export default ButtonWallComponent
